import {
    SubChartConverter,
} from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/sub-chart-converter';
import { ChartShapeInfoConverter } from '../../common/chart-shape-info-converter';
import type { DeltaOf, IOfPieChartData } from '@tencent/slide-sdk-model';
import type { IOfPieChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';
import type { IChartBaseShapeProps } from '../../common/chart-shape-info-converter';
import type { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';

export class OfPieChartConverter extends SubChartConverter {
    public static type = SubChartType.OfPieChart;
    public static convertSubChartDataSdkToUi(
        sdkData: IOfPieChartData,
        uiData: IOfPieChart,
    ) {
        super.convertSubChartDataSdkToUi(sdkData, uiData);
        if (this.isInnerValNotNil(sdkData.ofPieType)) {
            uiData.ofPieType = sdkData.ofPieType.val;
        }
        if (this.isInnerValNotNil(sdkData.gapWidth)) {
            uiData.gapWidth = sdkData.gapWidth.val;
        }
        if (this.isInnerValNotNil(sdkData.splitType)) {
            uiData.splitType = sdkData.splitType.val;
        }
        if (this.isInnerValNotNil(sdkData.secondPieSize)) {
            uiData.secondPieSize = sdkData.secondPieSize.val;
        }
        if (this.isInnerValNotNil(sdkData.splitPos)) {
            uiData.splitPos = sdkData.splitPos.val;
        }
        if (sdkData.custSplit?.secondPiePt) {
            uiData.secondPiePts = sdkData.custSplit?.secondPiePt.map(secondPiePt => secondPiePt.val as number);
        }
        if (sdkData.serLines) {
            uiData.serLines = sdkData.serLines.map((serLine) => {
                const newSerLine = {} as unknown as IShapeModel;
                ChartShapeInfoConverter.convertPartialDataFromSdkToUi(
                    serLine as unknown as IChartBaseShapeProps,
                    newSerLine,
                );
                return newSerLine;
            });
        }
    }

    public static convertSubChartDataUiToSdk(
        uiData: IOfPieChart,
        sdkData: DeltaOf<IOfPieChartData>,
    ) {
        super.convertSubChartDataUiToSdk(uiData, sdkData);

        this.convertComplexValueUiToSdk(uiData, 'ofPieType', sdkData, 'ofPieType');
        this.convertComplexValueUiToSdk(uiData, 'gapWidth', sdkData, 'gapWidth');
        this.convertComplexValueUiToSdk(uiData, 'splitType', sdkData, 'splitType');
        this.convertComplexValueUiToSdk(uiData, 'secondPieSize', sdkData, 'secondPieSize');
        this.convertComplexValueUiToSdk(uiData, 'splitPos', sdkData, 'splitPos');

        if (uiData.secondPiePts !== undefined) {
            if (uiData.secondPiePts === null) {
                sdkData.custSplit = null;
            } else {
                sdkData.custSplit = sdkData.custSplit ?? {};
                (sdkData.custSplit.secondPiePt as any) = uiData.secondPiePts.map(pt => (pt ? { val: pt } : undefined));
            }
        }

        if (uiData.serLines !== undefined) {
            if (uiData.serLines === null) {
                (sdkData.serLines as any) = null;
            } else {
                sdkData.serLines = uiData.serLines.map((serLine) => {
                    if (!serLine) {
                        return serLine;
                    }

                    const sdkSerLine = {};
                    ChartShapeInfoConverter.convertPartialDataFromUiToSdk(serLine, sdkSerLine);

                    return sdkSerLine;
                });
            }
        }
    }
}

